module.exports = __webpack_public_path__ + "img/29.6f34231a.jpg";